import { uploadData } from "aws-amplify/storage";

export async function s3Upload(file) {
    const filename = `${Date.now()}-${file.name}`;

    await uploadData({
        path: ({identityId}) => `private/${identityId}/${filename}`,
        data: file,
        options: {
            contentType: file.type
        }
    }).result;

    return filename;
}
